import { DATE_TIME_NAME_PDF } from 'constant/date'
import dayjs from 'dayjs'

export * from './constant'
export * from './cookie'
export * from './dataTime'

/**Chau Tran: Add class */
export * from './temperature'

export const getNamePdf = () => {
    const nameHard = "まるくるシステム"
    const date = dayjs(new Date())
    const nameDateTime = date.format(DATE_TIME_NAME_PDF)
    return `${nameHard}_${nameDateTime}`
}

export const getMsgError = (errorResponse: any) => {
    try {
        const dataMsg = typeof errorResponse?.data === "string" ? "" : errorResponse?.data || {}
        const arrayMsg = Object.values(dataMsg)
        return (errorResponse?.data?.error || errorResponse?.data?.messages || errorResponse?.data?.message || arrayMsg[0] || "") as string
    } catch (e: any) {
        return ""
    }
}



const getExtension = (name: string) =>
    name.split(".").pop()?.toLowerCase() || "";

export const isHttpUrl = (value?: string) =>
    typeof value === "string" && /^https?:\/\//i.test(value);

export const detectType = (name: string, mime?: string) => {
    const ext = getExtension(name);

    // ===== IMAGE =====
    if (
        mime?.startsWith("image/") ||
        [
            "png", "jpg", "jpeg", "gif", "webp", "bmp",
            "svg", "ico", "tiff", "avif"
        ].includes(ext)
    )
        return "image";

    // ===== VIDEO =====
    if (
        mime?.startsWith("video/") ||
        [
            "mp4", "webm", "ogg", "mov", "avi", "mkv"
        ].includes(ext)
    )
        return "video";

    // ===== AUDIO =====
    if (
        mime?.startsWith("audio/") ||
        [
            "mp3", "wav", "ogg", "aac", "flac", "m4a"
        ].includes(ext)
    )
        return "audio";

    // ===== PDF =====
    if (mime === "application/pdf" || ext === "pdf")
        return "pdf";

    // ===== TEXT =====
    if (
        mime?.startsWith("text/") ||
        [
            "txt", "log", "csv", "json", "xml", "md"
        ].includes(ext)
    )
        return "text";

    // ===== OFFICE =====
    if (
        [
            "doc", "docx",
            "xls", "xlsx",
            "ppt", "pptx"
        ].includes(ext)
    )
        return "office";

    return "other";
};

export function hexToRgba(hex: string, alpha = 0.3) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}